import styled from "styled-components";

export const AuthContainer = styled.div`
    min-height: 100%;
    display: flex;
    flex-direction: ${(props) => (props.isMobile ? "column-reverse" : "row")};
    align-items: center;
    justify-content: center;
    padding: ${(props) => (props.isMobile ? "48px 0 100px" : "32px 0")};
`;

export const AuthSection = styled.div`
    flex: 1;

    form {
        width: 88%;
        max-width: 400px;
        text-align: center;
        margin: 0 auto;
    }

    .MuiFormControlLabel-label {
        font-size: 10px;
        text-align: left;
    }
`;

export const AuthVideo = styled.div`
    border-right: ${(props) =>
        props.isMobile
            ? "none"
            : `1px solid ${props.theme.palette.background.paper}`};
    text-align: center;
    flex: 1;
    padding-bottom: ${(props) => (props.isMobile ? "12px" : "0")};

    div {
        width: 86%;
        margin: 0 auto;
        border-radius: 24px 24px 0 0;
        border-top: ${(props) =>
            `1px solid ${props.theme.palette.background.paper}`};
        overflow: hidden;
        position: relative;
    }

    aside {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
            180deg,
            rgba(24, 24, 24, 0) 0%,
            #232323 100%
        );
    }

    video {
        width: 100%;
        height: auto;
    }

    h1 {
        margin-top: -60px;
        line-height: 36px;
        z-index: 2;
        position: relative;
    }

    h2 {
        max-width: 80%;
        margin: 36px auto 0 auto;
    }
`;

export const AuthForm = styled.form`
    width: 100%;
    text-align: center;
    margin: ${(props) => (props.isMobile ? "40px auto 0" : "80px auto 0")};

    .MuiFormControlLabel-label {
        font-size: 10px;
        text-align: left;
    }
`;
export const CenteredAuthForm = styled(AuthForm)`
    flex: 1 1 0px;
    width: 88%;
    max-width: 400px;
    text-align: center;
    margin: 40px auto 0;
    position: relative;

    .MuiFormControlLabel-label {
        font-size: 10px;
        text-align: left;
    }
`;

export const AuthFormCentered = styled.div`
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
`;

export const Heading = styled.h1`
    font-size: 36px;
    font-weight: 600;
    margin: 0;
`;

export const SubHeading = styled.h2`
    font-size: 18px;
    font-weight: normal;
    margin: 0;
`;

export const GoogleLoginButton = styled.div`
    > div {
        display: flex;
        justify-content: center;
    }
`;

export const OrLine = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${(props) => props.backgroundColor};
`;

export const Footer = styled.div`
    margin: 40px auto 0 auto;
    display: flex;
    justify-content: ${(props) =>
        props.flexEnd ? "flex-end" : "space-between"};
    align-items: center;
    max-width: 400px;
    width: 100%;

    a {
        cursor: pointer;
    }
`;

export const StepCount = styled.div`
    font-size: 12px;
    color: ${(props) => props.color};
`;

export const FullImage = styled.div`
    width: 100%;
    height: 100%;
    background-position: center center;
    background-size: cover;
    background-image: ${(props) => `url('${props.url}')`};
`;

export const AuthStepsContainer = styled.div`
    overflow: hidden;
`;

const AuthSlider = styled.div`
    display: flex;
    flex-wrap: nowrap;
    width: ${(props) => `${props.count * 100}%`};
    transform: ${(props) =>
        `translateX(-${(100 / props.count) * props.current}%)`};
    transition: transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);
`;

export const AuthSteps = styled(AuthSlider)`
    justify-content: space-around;
`;

export const AuthStep = styled.div`
    width: 100%;
    max-width: 400px;
`;

export const AuthStepButton = styled.div`
    margin-top: 40px;
`;

export const AuthUpload = styled.div`
    background-color: ${(props) => props.backgroundColor || "#f2f2f2"};
    padding: 34px;
    border: ${(props) =>
        props.active ? "1px solid black" : "1px solid #f2f2f2"};
`;

export const InitScreen = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.backgroundColor || "#fff"};
    z-index: 10000;
`;
